import { memo } from 'react';
import { css } from '@bts-web/utils-style-engine';
import {
  capitalizeFirstLetter,
  intlAssetValueFormatting,
} from '@bts-web/utils-formatting';
import { useTradeForm } from '../hooks/useTradeForm/useTradeForm';
import { TradeFormProps } from '../types';
import { VerificationLinkButton } from '../../MainTradeVerificationLinkButton/MainTradeVerificationLinkButton';
import {
  AmountInputWrapper,
  BelowInputInfoTable,
  Divider,
} from '../../../../common';

export const VerificationLinkForm = memo(
  ({
    isDataLoading,
    formState,
    staticValues,
    currentTradeDetails,
    verifyLink,
  }: {
    isDataLoading: boolean;
    formState: ReturnType<typeof useTradeForm>['formState'];
    staticValues: TradeFormProps['staticValues'];
    currentTradeDetails: TradeFormProps['currentTradeDetails'];
    verifyLink: string;
  }) => (
    <>
      <AmountInputWrapper inputContextData={formState.inputContextData} />

      <div className={css({ pb: 'medium', pt: 'small' })}>
        <BelowInputInfoTable
          items={[
            {
              title: capitalizeFirstLetter(
                staticValues.translations['units'],
                true,
              ),
              value: formState.convertedSummary,
            },

            {
              title: staticValues.translations['minimum'],
              value: intlAssetValueFormatting(
                currentTradeDetails.minimumTradeAmount.FIAT?.value ?? 0,
                {
                  currency: staticValues.currency,
                  locale: staticValues.currentLocale,
                },
              ),
            },
          ]}
        />
      </div>

      <Divider />

      <VerificationLinkButton
        isDataLoading={isDataLoading}
        poweredByText={staticValues.translatedValues.poweredByText}
        verifyButtonText={staticValues.translatedValues.verifyButtonText}
        verificationLink={verifyLink}
        verifyTradeInfoText={staticValues.translatedValues.verifyInfoText}
      />
    </>
  ),
);
